import { getDialogComponent } from "components/MinimizedDialogs/registry";
import { useMinimizedDialogs } from "providers/minimizedDialogs";
import { useMemo } from "react";

export function MinimizedDialogsToolbar() {
  const { dialogs, close } = useMinimizedDialogs();

  const { centeredDialog, trayDialogs } = useMemo(() => {
    const centered = dialogs.find((d) => d.mode === "centered");
    const tray = dialogs.filter((d) => d.mode === "minimizedInTray" || d.mode === "expandedInTray");
    return { centeredDialog: centered, trayDialogs: tray };
  }, [dialogs]);

  if (dialogs.length === 0) {
    return null;
  }

  // Render all dialogs in one place to maintain the same instance during transitions
  return (
    <>
      {centeredDialog &&
        (() => {
          const DialogComponent = getDialogComponent(centeredDialog.dialogType);
          if (!DialogComponent) {
            return null;
          }
          return (
            <DialogComponent
              key={centeredDialog.id}
              {...centeredDialog.props}
              open={true}
              mode="centered"
              onClose={() => close(centeredDialog.id)}
            />
          );
        })()}

      {trayDialogs.map((dialog, index) => {
        const DialogComponent = getDialogComponent(dialog.dialogType);
        if (!DialogComponent) {
          return null;
        }

        return (
          <DialogComponent
            key={dialog.id}
            {...dialog.props}
            open={true}
            mode={dialog.mode}
            trayIndex={trayDialogs.length - 1 - index}
            onClose={() => close(dialog.id)}
          />
        );
      })}
    </>
  );
}
